import React from 'react';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { ExperimentSpecs } from '../../constants';
import { BaseVoucherBanner } from './VoucherBanner';
import { useIsMobile } from '../../hooks/useIsMobile';
export const AnonymousVoucherBanner = _ref => {
  var _getPremiumEssentials;
  let _ref$optimizedVoucher = _ref.optimizedVoucherCopy,
    optimizedVoucherCopy = _ref$optimizedVoucher === void 0 ? false : _ref$optimizedVoucher;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    tSuite = _DomainSearchSuiteMod.t;
  const isMatchCycle = !!((_getPremiumEssentials = getPremiumEssentialsSafe()) != null && (_getPremiumEssentials = _getPremiumEssentials.experiments) != null && _getPremiumEssentials[ExperimentSpecs.MatchDomainCycleToPremiumCycle]);
  const isMobile = useIsMobile();
  let bannerContent;
  if (optimizedVoucherCopy) {
    bannerContent = isMobile ? tSuite('domains_search_suite.storefront.optimizations.voucher_banner') : tSuite('domains_search_suite.anon_storefront_results.optimizations.initial_vs_renewal.banner');
  } else if (isMatchCycle) {
    bannerContent = isMobile ? t('domain_search_gate.mobile.banner.promo.no_voucher.match_cycle.title') : t('domain_search_gate.storefront_results.match_cycle.banner');
  } else {
    bannerContent = isMobile ? t('domain_search_suite.mobile.banner.promo.no_voucher.title') : t('domain_search_gate.storefront_results.free_one_year.banner');
  }
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: bannerContent
  });
};
//# sourceMappingURL=AnonymousVoucherBanner.js.map